import React, { useEffect, useState } from "react";
import { getRequest, postRequest } from "../../../../../../services/api/apiService";
import { toast } from "react-toastify";

const ConnectedPlatformAccountSnapchatConfigurationModal = ({
  platformName,
  headers,
  onClose,
  handleFetchConnectedPlatforms,
}) => {
  const [snapchatAdsAccountId, setSnapchatAdsAccountId] = useState("");
  const [adAccounts, setAdAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        // Fetch available ad accounts (all orgs → all ad accounts)
        const listRes = await getRequest(
          "/api/ads/snapchat/fetch-available-ad-accounts",
          { ...headers }
        );
        setAdAccounts(listRes.data || []);

        // Pre-select the currently saved account
        const currentRes = await getRequest(
          "/api/ads/snapchat/fetch-snapchat-ads-account",
          { ...headers }
        );
        const savedId = currentRes.data?.snapchat_ads_account_id;
        if (savedId) setSnapchatAdsAccountId(savedId);
      } catch (err) {
        setError("Failed to load Snapchat ad accounts.");
      }
    };
    load();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async () => {
    if (!snapchatAdsAccountId) {
      setError("Please select a Snapchat Ads Account.");
      return;
    }
    try {
      setLoading(true);
      setError(null);
      await postRequest(
        "/api/ads/snapchat/save-snapchat-ads-account",
        { snapchatAdvertiserId: snapchatAdsAccountId },
        { ...headers }
      );
      toast.success("Snapchat Ads Account updated successfully!");
      onClose();
      handleFetchConnectedPlatforms();
    } catch (err) {
      setError("An error occurred while saving the Snapchat Ads account.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Snapchat Ads Account
          </label>
          <select
            value={snapchatAdsAccountId}
            onChange={(e) => setSnapchatAdsAccountId(e.target.value)}
            className="mt-1 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
          >
            <option value="" disabled>
              Select Snapchat Ad Account
            </option>
            {adAccounts.map((acc) => (
              <option key={acc.id} value={acc.id}>
                {acc.name ? `${acc.name} (${acc.id})` : acc.id}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="text-xs text-gray-500 italic mb-6">
        Select the ad account to use for Snapchat campaigns.
      </div>

      {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

      <div className="flex justify-end gap-4">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
        >
          Cancel
        </button>
        <button
          onClick={save}
          disabled={loading}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default ConnectedPlatformAccountSnapchatConfigurationModal;
